import {memo} from 'react';

import type {Size} from '#theme';

import type {Icons} from '../../../atoms/icon/icons.js';
import {ToggleMenuButton} from '../components/toggle_menu_button.js';
import {useMultiComboBoxContext} from '../context.js';

type ToggleButtonProps = {
  size?: Size;
  icon?: Icons;
  className?: string;
};

const ToggleButton = memo(function ToggleButton({
  icon,
  size,
  className,
}: ToggleButtonProps) {
  const {isOpen, getToggleButtonProps, toggleAriaLabel} =
    useMultiComboBoxContext();

  return (
    <ToggleMenuButton
      {...getToggleButtonProps()}
      ariaLabel={toggleAriaLabel}
      icon={icon}
      size={size}
      isOpen={isOpen}
      className={className}
    />
  );
});

export {ToggleButton};
